export default __webpack_public_path__ + "static/media/email-not-received.1db50e38.svg";